module.exports = __webpack_public_path__ + "static/media/we-right-top.1e88f612.png";